import React, { useState, useEffect, useRef, useCallback } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Button } from "../../UI";
import { IoIosArrowDown } from "react-icons/io";
import { PreviousOrder, TrackOrder } from "../../assets/icons";
import { doesRouteMatch } from "../../helpers";
import pickOrder from "../../assets/pickOrder.svg";
import Container from "./styles";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../store/actions";

const Navigation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const orderRef = useRef(null);
  const { pathname } = useLocation();
  const { authenticated } = useSelector((s) => s.UserData);
  const [slide, setSlide] = useState(false)
  const [displayState, setDisplay] = useState({
    showNav: false,
    showPopup: false
  });
  const { showNav, showPopup } = displayState;

  const handleBodyClick = useCallback(
    (e) => {
      if (slide && e.target.isSameNode !== orderRef.current) {
        setSlide(false);
      }
    },
    [slide]
  );

  useEffect(() => {
    document.addEventListener("click", handleBodyClick);
    return () => {
      document.removeEventListener("click", handleBodyClick);
    };
  }, [handleBodyClick]);

  useEffect(() => {
    const body = document.getElementsByTagName("html")[0];
    if (body) {
      if (showNav) {
        body.style.overflowY = "hidden";
      } else {
        body.style.overflowY = "auto";
      }
    }
  }, [showNav]);

  const handleNavClick = () => {
    setDisplay((s) => ({ ...s, showNav: false }));
  };

  return !doesRouteMatch(
    ["delievery-request", "auth", "dashboard"],
    pathname
  ) ? (
    <Container>
      <div className="navigation--container">
        <div
          className="brandLogo--container"
          onClick={() => {
            navigate("/home");
            window.scroll({
              top: 0,
              behavior: "smooth"
            });
          }}
        >
          <img src={pickOrder} alt="Pick Order" />
        </div>
        <nav className={showNav ? "nav--mobile" : "nav--mobile__close"}>
          <div className="nav--item">
            <NavLink to="/home" onClick={handleNavClick}>
              Home
            </NavLink>
          </div>
          {authenticated && (
            <>
              <div className="nav--item" >
                <NavLink to="/dashboard" onClick={handleNavClick}>
                  Dashboard
                </NavLink>
              </div>
            </>
          )}
          {!authenticated && (
            <div className="nav--item">
              <NavLink to="/track-order" onClick={handleNavClick}>
                Track your orders
              </NavLink>
            </div>
          )}
          <div className="nav--item">
            <NavLink to="/support" onClick={handleNavClick}>
              Support
            </NavLink>
          </div>

          {!authenticated && (
            <div className="nav--item">
              <NavLink 
                to="/auth/sign-in" 
                onClick={handleNavClick}
                style={{ 
                  background: '#091029', 
                  color: 'white', 
                  padding: '8px 20px', 
                  borderRadius: '4px',
                  textDecoration: 'none'
                }}
              >
                Login
              </NavLink>
            </div>
          )}

          {authenticated && (
            <div className="nav--item">
              <div
                onClick={() => {
                  dispatch(logout(navigate));
                }}
                style={{ cursor: 'pointer' }}
              >
                Log out
              </div>
            </div>
          )}
        </nav>
        <Button
          className={`nav--btn 
            ${showNav ? "open" : "close"}`}
          onClick={() => setDisplay((s) => ({ ...s, showNav: !showNav }))}
        >
          <span className="dash" />
        </Button>
      </div>
    </Container>
  ) : null;
};

export default Navigation;
